import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { useDonation } from "../Components/DonationContext";
import { useNavigate } from "react-router-dom";
import "./AdvocacyAndNetworking.css";
import "./ProgramsBanner.css";

// Animation variants for Framer Motion
const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.3,
    },
  },
};

const staggerItem = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

/* ---------------- Inline icon set (no external icon package needed) ---------------- */

const IconHandshake = ({ color = "#ffffff" }) => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 22l8-7 8 5 5-3 15 10-4 5-3-2-9 8-11-6-2 3-7-5z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M22 20l8 6M27 15l9 6" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconHeartHands = ({ color = "#ffffff" }) => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 30c-3.5-3.4-6-6.6-6-10.4a5.4 5.4 0 0111-1.1 5.4 5.4 0 0111 1.1c0 3.8-2.5 7-6 10.4l-5 4.8-5-4.8z"
      stroke={color}
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M8 28c-1.6 2-3 4.4-3 7 0 3.6 3 6.5 6.5 6.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M40 28c1.6 2 3 4.4 3 7 0 3.6-3 6.5-6.5 6.5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const IconNetwork = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="10" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="10" cy="34" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="38" cy="34" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <path d="M24 14v10M20 26l-7 5M28 26l7 5" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconGroup = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="14" r="5" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="12" cy="19" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="36" cy="19" r="4" stroke="#1a6b3c" strokeWidth="2" />
    <path d="M14 34c0-6.5 4.5-10.5 10-10.5s10 4 10 10.5" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
    <path d="M6 32c.6-4.5 3-7 6.5-7.6M42 32c-.6-4.5-3-7-6.5-7.6" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const IconMegaphone = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 20v8a2 2 0 002 2h3l14 6V12l-14 6H10a2 2 0 00-2 2z" stroke="#1a6b3c" strokeWidth="2" strokeLinejoin="round" />
    <path d="M27 18a6 6 0 010 12" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" />
    <path d="M13 30v6a2 2 0 002 2h1a2 2 0 002-2v-4" stroke="#1a6b3c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconTarget = () => (
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="24" cy="24" r="15" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="24" cy="24" r="9" stroke="#1a6b3c" strokeWidth="2" />
    <circle cx="24" cy="24" r="3" fill="#1a6b3c" />
    <path d="M32 16l6-6M38 10v5h-5" stroke="#ef7f3a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const IconHeart = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21s-7.5-4.6-10-9.3C.4 8.3 2 4.5 5.6 4c2.1-.3 4 .8 6.4 3 2.4-2.2 4.3-3.3 6.4-3 3.6.5 5.2 4.3 3.6 7.7C19.5 16.4 12 21 12 21z" />
  </svg>
);

const IconUsers = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="8" r="3.2" stroke="currentColor" strokeWidth="1.8" />
    <path d="M2.8 20c.7-3.6 3.3-5.6 6.2-5.6s5.5 2 6.2 5.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M15.5 5.4a3.2 3.2 0 010 6.2M18.8 20c-.5-2.6-1.9-4.4-3.8-5.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const IconHandHeart = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24 38c-4-4-7-8-7-13a7 7 0 0114-1 7 7 0 0114 1c0 5-3 9-7 13l-7 7-7-7z"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinejoin="round"
    />
    <path
      d="M14 34c-3 3-6 7-6 12 0 5 4 9 9 9h9c4 0 7-2 10-5l9-9c1.5-1.5 1.5-3.7 0-5-1.4-1.3-3.4-1.2-4.8.1l-6.2 6"
      fill="#ef7f3a"
    />
  </svg>
);

/* ------------------------------------------------------------------------------------ */

const AdvocacyAndNetworking = () => {
  const initiatives = [
    {
      title: "Developing a Network",
      text: "Building a strong network of thinkers and development professionals committed to social change.",
      icon: <IconNetwork />,
    },
    {
      title: "Collaborating with NGOs",
      text: "Partnering with NGOs on education and childcare initiatives in tribal and underserved areas.",
      icon: <IconGroup />,
    },
    {
      title: "State & National Campaigns",
      text: "Undertaking campaigns on early childhood education at state and national levels to influence policy and practice.",
      icon: <IconMegaphone />,
    },
    {
      title: "Stakeholder Engagement",
      text: "Leveraging our presence in 13 districts to reach out to stakeholders effectively and create lasting impact.",
      icon: <IconHandshake color="#1a6b3c" />,
    },
  ];

  const { openDonation } = useDonation();
  const navigate = useNavigate();

  return (
    <>
      <Header />

      {/* Hero Section */}
      <section className="adv-hero">
        <div
          className="adv-hero__bg"
          style={{
            backgroundImage: "url(/assets/images/backgrounds/page-header-bg.jpg)",
          }}
        ></div>
        <div className="adv-hero__overlay"></div>
        <div className="adv-hero__dots"></div>

        <div className="adv-hero__logo">
          <IconHandHeart />
        </div>

        <svg className="adv-hero__wave" viewBox="0 0 200 260" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 2c30 20-20 45 10 65s45-10 60 15-10 40 20 60"
            stroke="#ef7f3a"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>

        <Container className="adv-hero__content">
          <motion.h1
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            Advocacy and
            <br />
            <span>Networking</span>
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            Vikash builds strategic partnerships and campaigns to amplify
            community voices and drive systemic change.
          </motion.p>
        </Container>
      </section>

      {/* Master card wrapping intro + strategies + CTA */}
      <section className="adv-wrap">
        <Container>
          <div className="adv-card">
            {/* Introduction */}
            <div className="adv-intro">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
              >
                <Row className="align-items-center g-5">
                  <motion.div className="col-lg-6" variants={staggerItem}>
                    <div className="adv-icon-circle">
                      <IconHandshake />
                    </div>
                    <div className="adv-eyebrow">
                      <span className="adv-eyebrow__dash"></span>
                      Voice for Change
                    </div>
                    <h2 className="adv-heading">
                      Amplifying
                      <br />
                      <span>Community Voices</span>
                    </h2>
                    <p className="adv-text">
                      Vikash has developed a robust network of thinkers and
                      development professionals to conduct advocacy with
                      and for the community. We work closely with a
                      network of NGOs on critical issues like education
                      and childcare in tribal areas. Our presence across
                      13 districts of Odisha enables us to effectively
                      reach out to all stakeholders and run impactful
                      campaigns at both state and national levels.
                    </p>

                    <div className="adv-badge">
                      <div className="adv-badge__icon">
                        <IconUsers />
                      </div>
                      <div>
                        <strong>Stronger voices. Greater impact.</strong>
                        <p>
                          Together, we drive systemic change for a more
                          equitable society.
                        </p>
                      </div>
                    </div>
                  </motion.div>

                  <motion.div className="col-lg-6" variants={staggerItem}>
                    <img
                      src="/assets/images/Subsections/a1.jpeg"
                      alt="Advocacy meeting in session"
                      className="adv-intro__img"
                    />
                  </motion.div>
                </Row>
              </motion.div>
            </div>

            {/* Core Strategies */}
            <div className="adv-strategies">
              <div className="adv-strategies__dots"></div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={fadeIn}
                className="text-center adv-strategies__head"
              >
                <div className="adv-target">
                  <IconTarget />
                </div>
                <h2 className="adv-heading adv-heading--center">
                  Our Core <span>Strategies</span>
                </h2>
                <span className="adv-underline adv-underline--center"></span>
                <p className="adv-subtext">
                  We leverage collaboration and strategic outreach to
                  drive meaningful change.
                </p>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={staggerContainer}
              >
                <Row className="g-4 justify-content-center">
                  {initiatives.map((item, index) => (
                    <Col md={6} key={index}>
                      <motion.div variants={staggerItem} className="h-100">
                        <Card className="adv-card-item h-100">
                          <Card.Body className="d-flex align-items-start">
                            <div className="adv-card-item__icon">
                              {item.icon}
                            </div>
                            <div>
                              <Card.Title as="h5">{item.title}</Card.Title>
                              <span className="adv-card-item__underline"></span>
                              <Card.Text>{item.text}</Card.Text>
                            </div>
                          </Card.Body>
                        </Card>
                      </motion.div>
                    </Col>
                  ))}
                </Row>
              </motion.div>
            </div>

            {/* Call To Action */}
            <div className="adv-cta">
              <div className="adv-cta__dots"></div>
              <Row className="align-items-center g-4">
                <Col lg={6}>
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={fadeIn}
                  >
                    <div className="adv-cta__icon">
                      <IconHeartHands />
                    </div>
                    <h2 className="adv-cta__title">
                      Support
                      <br />
                      <span>Our Campaigns</span>
                    </h2>
                    <span className="adv-underline"></span>
                    <p className="adv-cta__text">
                      Your contribution helps us advocate for policy
                      changes and build networks that empower vulnerable
                      communities.
                    </p>
                    <div className="adv-cta__actions">
                      <Button
                        className="adv-btn adv-btn--solid"
                        onClick={openDonation}
                      >
                        <IconHeart /> Donate Now
                      </Button>
                      <Button
                        className="adv-btn adv-btn--outline"
                        onClick={() => navigate("/interns")}
                      >
                        <IconUsers /> Join Us
                      </Button>
                    </div>
                  </motion.div>
                </Col>

                <Col lg={6}>
                  <div className="adv-cta__imgwrap">
                    <div className="adv-cta__swoosh"></div>
                    <img
                      src="/assets/images/backgrounds/do2.png"
                      alt="Children celebrating"
                      className="adv-cta__img"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section>

      <Footer />

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <span className="scroll-to-top__wrapper">
          <span className="scroll-to-top__inner" />
        </span>
        <span className="scroll-to-top__text"> Go Back Top</span>
      </a>
    </>
  );
};

export default AdvocacyAndNetworking;